import React, { Component } from 'react';
import {NewsItem} from '../components/newsItem.js';
import {PageNav} from '../components/pageNav.js';
import {Link} from 'react-router-dom';
import {Footer} from '../components/footer.js';

export class News extends Component {
    state = { 

        // 90 ish line

        // id=number which will show up in url as /NewsPage/id
        // year = year news was published in, for use in filtering by year
        // title: title which will show up in bold red on the card
        // text: text will also show up on card, the more text put the longer the card will be
        //       -if too much text, just use "..." at the end

        // any new keys added can be accessed from src/components/newsItem.js using a variable called 
        // "this.props.info", which is equal to a DICTIONARY (not list of dictionaries, like the news variable below)
        // For example, if a new key called "example" is added, this can be accessed through this.props.info.example or
        // this.props.info['example']

        // when adding to news, make sure to duplicate it into newsReset too so filters will reset properly
        news: [

{id: 24, year: 2025, title: 'AGT Welcomes Sheng Xu as Chief Geophysicist',
text: 'AUG/2025',
text1: 'We’re thrilled to welcome Sheng Xu to the AGT team as our new Chief Geophysicist! Sheng brings a wealth of expertise and a global reputation in seismic imaging, and he’s ready to help us push the boundaries of what’s possible in the subsurface world.',
text2: 'Working closely with AGT’s executive team, Sheng will spearhead the development of game-changing imaging technologies, support our commercial growth, and help cement AGT’s place as a leader in the seismic imaging marketplace.',
text3: 'With an impressive career that includes leading research at Equinor and serving as VP of Research at CGGVeritas, Sheng knows how to turn bold ideas into real-world breakthroughs. We can’t wait to see the innovation and energy he brings to the team. Welcome aboard, Sheng!'},

{id: 23, year: 2025, title: 'AGT Launches Next-Generation Elastic FWI with Finite Element Technology',
text: 'JUL/2025',
text1: 'AGT is excited to introduce a breakthrough in seismic imaging— our Finite Element Elastic Full Waveform Inversion (FWI) workflow. This innovation is the result of years of dedicated R&D into our proprietary finite element method for seismic modelling, now applied to deliver superior velocity model building for seismic imaging projects.',
text2: 'Why does it matter? Finite element methods excel where others struggle, handling complex topography and rugose surfaces with higher technical accuracy, while being more efficient than traditional finite difference approaches. With this, we can build better models, deliver faster turnaround, and achieve sharper imaging for your toughest geophysical challenges'},

{id: 22, year: 2025, title: 'AGT Expands Scope of CO₂ Project with SEAM Consortium',
text: 'FEB/2025',
text1: 'We’re turning up the volume on our CO₂ project!  AGT has signed an amendment to its contract with the SEAM Consortium, expanding our work and adding even more subsurface datasets to the mix.',
text2: 'This expanded scope will give us deeper insights and a stronger technical foundation, helping drive forward the project’s long-term goals. In short.. more data, smarter science, and better outcomes for the CO₂ challenge.'},

{id: 21, year: 2024, title: 'AGT Collaborates with ARGAS to Expand Technologies and Services in the Middle East',
text: 'OCT/2024',
text1: 'Big news from the desert sands!  AGT has teamed up with Arabian Geophysical and Survey Company (ARGAS) to bring our advanced imaging technologies and services to the Middle East and North Africa (MENA) region.',
text2: 'Founded in 1966, ARGAS is a leader in seismic acquisition and a subsidiary of TAQA, which is part of the Saudi sovereign Public Investment Fund (PIF). Together, we’ll power up regional exploration efforts and even support ARGAS’s technical needs for their data acquisition business. MENA — here we come!'},

{id: 20, year: 2024, title: 'AGT Expands Computing Capacity in Malaysia with IPserverone Colocation Agreement',
text: 'AUG/2024',
text1: 'AGT has expanded its computing capabilities in Malaysia through a colocation agreement with IPserverone, located just outside Kuala Lumpur. This facility will serve as a key hub supporting AGT’s growth in Southeast Asia.',
text2: 'The large, robust, and highly secured data center will house AGT’s multi-petaflop computer systems, enabling enhanced capacity and performance for the company’s geophysical services across the region.'},

{id: 19, year: 2024, title: 'AGT Malaysia Welcome Christopher Lee Slind as SEA Regional Manager',
text: 'MAY/2024',
text1: 'With 36+ years of advanced seismic imaging expertise across global basins—including leadership roles at PETRONAS and CGGVeritas, Chris is now heading up AGT’s seismic services across SEA from Kuala Lumpur.',
text2: 'He’ll lead our core offerings in 2D/3D/4D processing, broadband, OBN, and elastic forward modelling, while building strong technical collaborations across the region.',
text3: 'Fun fact: Chris once oversaw a seismic imaging team in Mexico, and can confirm that cockroaches are good swimmers!',
text4: 'Welcome aboard, Chris! We’re excited for what’s next for AGT in SEA.'},

{id: 18, year: 2024, title: 'AGT Partners with Stratoil to Deliver Advanced Technologies to the Egyptian Market',
text: 'JAN/2024',
text1: 'We’re making waves on the Nile!  AGT has signed an agency agreement with Stratoil, a Cairo-based software and consulting firm specializing in subsurface, engineering, and training for the oil and gas world. ',
text2: 'Stratoil will lead local business development and provide technical support, helping us bring AGT’s cutting-edge technologies to Egypt’s exploration community. We’re ready to fuel innovation in one of the region’s most dynamic energy markets.'},
{id: 17, year: 2023, title: 'AGT Colombia',
text: 'DEC/2023',
text1: 'AGT is pleased to announce the establishment of our Colombian Branch office located in Bogota, Colombia. Built on the back of a two multi-year seismic processing and imaging contracts we have brought our suite of advanced seismic imaging tools and services to the Colombian market and by extension other areas in the South American region.  Services include seismic data processing of 2D/3D/4D Land/Marine including OBN and broadband acquisitions. Additionally, included in our offering is advanced 3D elastic (Finite Element) and acoustic forward modelling services. ',
text2: 'For further inquiries please reach out to Colombia@agtgeo.com. Phone: +57 3112382512. Address: Calle Av. 19 NO 118-95, Bogotá D.C. For additional inquiries please visit www.agtgeo.com. '},
{id: 16, year: 2023, title: '',
text: 'OCT/2023',
text1: 'AGT has been awarded by the SEG Advanced Modeling Corporation (SEAM) a contract for geophysical simulations (Elastic Modeling etc.) on their 3-year CO2 Sequestration Project.  The purpose of the project is to develop better CO2 subsurface management using synthetic numerical benchmarks. The work program will include numerical models, earth response and monitoring simulations. This continues multi-year awards, by AGT, for various SEAM projects over the last 10 years.  In addition, AGT manages all SEAM data under a separate Agreement.  We appreciate SEAM’s continued support of AGT technical capabilities in this highly compute intensive project. ',
text2: 'For further inquiries please contact AGT @  info@agtgeo.com or SEAM representative Paola Vera @ pvera@seg.org'},
{id: 15, year: 2023, title: '',
text: 'FEB/2023',
text1: 'AGT awarded long term 3+1-year contract for seismic processing contract with a local operator in Colombia.  AGT has already hired existing local workforce and project work been awarded related to the contract.'},
{id: 14, year: 2023, title: '',
text: 'FEB/2023',
text1: 'AGT is pleased to announce the establishment of our SE Asia subsidiary located in Kuala Lumpur, Malaysia. Built on the back of a multi-year processing and imaging contract we have brought our suite of advanced seismic imaging tools and services to the SE Asia region.',
text2: 'Services include seismic data processing of 2D/3D/4D Land/Marine including OBN and broadband acquisitions. Additionally, included in our offering is advanced 3D elastic (Finite Element) and acoustic forward modelling services and AGT handles the management of all SEG’s SEAM consortia data models.',
text3: 'This regional center provides services to the entire SE Asia region. AGT’s presence in the region is in conjunction with our local partners Elsa Energy and Azimuth GeoSolutions. ',
text4: 'For further inquiries please reach out to Malaysia@agtgeo.com .',
text5: 'For additional inquiries please visit www.agtgeo.com. BTW - we are hiring qualified geophysicists in Malaysia.'},
{id: 13, year: 2022, title: '',
text: 'JUL/2022',
text1: 'Through a long standing relationship with SEAM the SEG Advanced Modeling Corporation has chosen AGT to manage the entire SEAM product line of data. Please visit www.seg.org/SEAM/home for more detail.',
text2: 'MAY/2022',
text3: 'AGT is awarded by Ecopetrol S.A. a 3 + 1 year (2022-2026) Framework Agreement contract for seismic processing onshore data in Colombia.  Award based on AGT’s excellent results from the “turkey shoot” AGT performed as part of the benchmark for project award.  This continues a contractual relationship between AGT and Ecopetrol first established in 2018.'},
{id: 12, year: 2021, title: '',
text: 'DEC/2021:    ',
text1: 'AGT awarded SEAM AI Synthetic Data Benchmark project.  Includes synthetic seismic modeling, event identification and travel-time picking.',
text2: 'OCT/2021:    ',
text3:'AGT signs agreement with Invision Geofisica to bring AGT’s suite of advanced imaging technologies and services to the Brazilian market. AGT’s suite of marine imaging technologies including advanced velocity model building and migrations are perfectly suited to support 2D/3D marine acquisition initiatives especially for more recent nodal 3D acquisitions.',
text4:'AUG/2021:    ',
text5:'Multi-year contract award. AGT awarded 5-year marine processing and imaging contract with Nexus Cognitive Government Solutions for indefinite delivery, indefinite quantity of seismic imaging service. The initial work under this agreement has already been defined under two seprate work orders. Continuous work orders are expected under this agreement.',
text6:'APR/2021',
text7:'Multi-year umbrella contract award. AGT along with its Malaysian based partner Azimuth Geosolutions awarded 5-year umbrella contract with Petronas for 2D/3D processing and imaging services. This award primarily based AGT\'s suite of advanced signal processing, velocity model building, and migration technology consists of 2D/3D seismic imaging workflows including newly developed multiple attenuation techniques, velocity model building(i.e. QFWI) and advanced migrations(i. e. LS-PSDM, QRTM etc..). The data regimes are primarily for marine 3D projects in both shallow and deep water geologic environments.',
text8:'MAR/2021',
text9:'AGT signs new long-term lease and relocation to new facilities to accommodate growth in business. New office doubles existing capacity for its\' employees and fully supported with state-of-the-art infrastructure for AGT\' high capacity internally administered computer facility.'},
{id: 1, year: 2020, title: '', 
text:'APR/2020:    ',
text1:'AGT inks 3-year technology collaboration agreement with large IOC around new seismic imaging methodologies related to Machine Learning initiatives.',
text2:'APR/2020:    ',
text3:'AGT awarded 2-year Phase 2 DOE grant #DE-SC0019665 for “Enhance Full-Waveform Inversion with Machine Learned Low-Frequency Signals”.',
text4:'MAR/2020:',
text5:'AGT to present at EAGE workshop “Quantifying Uncertainty in Depth Imaging” in Kuala Lumpur Apr 6-8, 2020.  “Postponed until Oct 26-28 due to Covid-19”',
text6:'MAR/2020',
text7:'AGT files provisional patent for “Broadband full waveform inversion through alternating resotration and inversion of missing frequencies”.',
text8:'JAN/2020:',
text9:'AGT signs partnership agreement with Azimuth Geosolutions to provide seismic imaging and forward modelling services in Malaysia and SE Asia area markets.',
text10:'https://azimuthgeos.com/azimuth-agt/    '},
{id: 2, year: 2019, title: '', 
text:'SEP/2019',
text1:'AGT files patent for RTM angle gather workflow "Systems and methods for providing amplitude versus offset compliant RTMmigration gathers".',
text2:'AUG/2019',
text3:'AGT files provisional patent for "Progressive transfer for low frequency prediction in full waveform inversion".',
text4:'JUN//2019:    ',
text5:'AGT expands in-house multi-PetaFlop compute infrastructure due to significant increase in project awards requiring advanced imaging technologies.',
text6:'MAY/2019:    ',
text7:'AGT doing numerous 3D acquisition studies GOM & Mexico utilizing proprietary forward modeling technologies.',
text8:'APR/2019:    ',
text9:'AGT secures significant 3D work with Ecopetrol in Colombia',
text10:'MAR/2019:    ',
text11:'Signs agreement with University of Houston for support on DOE program.',
text12:'FEB/2019',
text13:'AGT awarded Phase 1 DOE grant #DE-SC0019665 for "Enhance Full-Waveform Inversion with Machine Learned Low-Frequency Signals".',
text14:'FEB/2019:',
text15:'AGT lands large elastic modeling contract offshore Brazil.'
},
{id: 11, year: 2018, title: '',
text:'OCT/2018:    ',
text1:'AGT awarded 3 year framework seismic processing contract for onshore Colombia with Ecopetrol ',
text2:'SEP/2018:    ',
text3:'AGT awarded large Elastic Modelling (Life of Field) contract from SEAM',
text4:'AUG/2018:    ',
text5:'AGT top tier in AVO compliant RTM angle gather benchmark',
text6:'APR/2018:    ',
text7:'Expands further to full-service imaging provider.  Adds staff.',
text8:'APR/2018:    ',
text9:'AGT hires Jack Robinson (35 years experience) to manage signal processing department at AGT.',
text0:'MAR/2018:     ',
text11:'AGT signs agreement with Samit, India for technology and technical support for processing and imaging services. Starts first project.',
text12:'JAN/2018',
text13:'AGT awarded Phase 1 NSF grant #NSF1746834 titled "Deep transfer learning enabled machine vision inspection and its application in exploration geophysics".'
},
{id: 10, year: 2017, title: '',
text:'AUG/2017:    ',
text1:'AGT top tier in AVO compliant RTM angle gather benchmark for major IOC',
text2:'AUG/2017:    ',
text3:'AGT awarded two marine Q-RTM projects',
text4:'MAR/2017:     ',
text5:'AGT office moves as part of expansion plan',
},
{id: 9, year: 2016, title: '',
text:'DEC/2016:    ',
text1:'AGT files Q-RTM patent ',
text2:'SEP/2016:    ',
text3:'AGT finished large SEAM elastic PP model in record time',
text4:'JUL/2016:    ',
text5:'AGT expands GPU compute 100%',
text6:'JUL/2016:    ',
text7:'AGT awarded 6th straight SEAM FM project'
},
{id: 8, year: 2015, title: '',
text:'OCT/2015:    ',
text1:'AGT China completes large software sale.',
text2:'SEP/2015',
text3:'Bill Burke joins AGT as VP Business Development.',
text4:'JUL/2015:     ',
text5:'AGT completes large onshore Q PSDM project.',
text6:'FEB/2015:     ',
text7:'AGT files patent for “Beat Tone” FWI.'
},
{id: 7, year: 2014, title: '',
text:'AUG/2014:    ',
text1:'AGT now in the Leading Edge. ',
text2:'JUN/2014:        ',
text3:'AGT awarded large FM project by large IOC.  Finishes in record time.',
text4:'JUN/2014:        ',
text5:'AGT adds additional hardware to their offsite compute facility due to higher demand for services.', 
text6:'FEB/2014:    ',
text7:'AGT expands service business offerings. Includes full range of depth imaging services',
text8:'JAN/2014:    ',
text9:'AGT office expansion continues:  Adds significantly more space.'
},
{id: 6, year: 2013, title: '',
text:'NOV/2013:    ',
text1:'AGT awarded SEAM Phase2 “Unconventionals” Forward Modeling project.',
text2:'OCT/2013:    ',
text3:'Rob Yorke hired by AGT as their CEO',
text4:'MAR/2013:        ',
text5:'Wenyi Hu joins AGT',
text6:'MAR/2013:        ',
text7:'AGT begins development of FWI technology',
},
{id: 5, year: 2012, title: '',
text:'SEP/2012:    ',
text1:'Jerry Yuan & Xijing Lian join AGT.',
text2:'MAY/2012:        ',
text3:'AGT invests in 1.4 PetaFlop GPU machine for 3D seismic imaging services.',
text4:'MAY/2012:        ',
text5:'Initial development of 3D Kirchhoff migration.',
text6:'MAR/2012:        ',
text7:'AGT establishes permanent presence in China.  Hires 1st employee.',
text8:'MAR/2012:    ',
text9:'AGT starts Velocity Model Building project.',
text10:'FEB/2012:    ',
text11:'Yong Sun joins AGT.',
text12:'JAN/2012:    ',
text13:'AGT office expansion.  Doubles office space.'
},
{id: 4, year: 2011, title: '',
text:'NOV/2011:    ',
text1:'AGT awarded SEAM Phase1(B) Deep Water Gulf of Mexico TTI Forward Modeling Project. ',
text2:'SEP/2011:    ',
text3:'AGT awarded 3 large RTM software licensing sale contracts.',
text4:'JUL/2011:        ',
text5:'AGT sign 1st contract for RTM software licensing sale.',
text6:'MAR/2011:        ',
text7:'AGT signs cooperation agreement with CUPC in Beijing.'
},
{id: 3, year: 2010, title: '',
text:'SEP/2010:     ',
text1:'AGT establish small office in Houston just outside of the Galleria.',
text2:'SEP/2010:  ',
text3:'AGT begins developing RTM migration software.',
text4:'AUG/2010: ',
text5:'Co-Founder Lijian Tan starts up operations.',
text6:'AUG/2010:        ',
text7:'AGT Incorporates.',
}
         ],
        newsReset: [

{id: 24, year: 2025, title: 'AGT Welcomes Sheng Xu as Chief Geophysicist',
text: 'AUG/2025',
text1: 'We’re thrilled to welcome Sheng Xu to the AGT team as our new Chief Geophysicist! Sheng brings a wealth of expertise and a global reputation in seismic imaging, and he’s ready to help us push the boundaries of what’s possible in the subsurface world.',
text2: 'Working closely with AGT’s executive team, Sheng will spearhead the development of game-changing imaging technologies, support our commercial growth, and help cement AGT’s place as a leader in the seismic imaging marketplace.',
text3: 'With an impressive career that includes leading research at Equinor and serving as VP of Research at CGGVeritas, Sheng knows how to turn bold ideas into real-world breakthroughs. We can’t wait to see the innovation and energy he brings to the team. Welcome aboard, Sheng!'},

{id: 23, year: 2025, title: 'AGT Launches Next-Generation Elastic FWI with Finite Element Technology',
text: 'JUL/2025',
text1: 'AGT is excited to introduce a breakthrough in seismic imaging— our Finite Element Elastic Full Waveform Inversion (FWI) workflow. This innovation is the result of years of dedicated R&D into our proprietary finite element method for seismic modelling, now applied to deliver superior velocity model building for seismic imaging projects.',
text2: 'Why does it matter? Finite element methods excel where others struggle, handling complex topography and rugose surfaces with higher technical accuracy, while being more efficient than traditional finite difference approaches. With this, we can build better models, deliver faster turnaround, and achieve sharper imaging for your toughest geophysical challenges'},

{id: 22, year: 2025, title: 'AGT Expands Scope of CO₂ Project with SEAM Consortium',
text: 'FEB/2025',
text1: 'We’re turning up the volume on our CO₂ project!  AGT has signed an amendment to its contract with the SEAM Consortium, expanding our work and adding even more subsurface datasets to the mix.',
text2: 'This expanded scope will give us deeper insights and a stronger technical foundation, helping drive forward the project’s long-term goals. In short.. more data, smarter science, and better outcomes for the CO₂ challenge.'},

{id: 21, year: 2024, title: 'AGT Collaborates with ARGAS to Expand Technologies and Services in the Middle East',
text: 'OCT/2024',
text1: 'Big news from the desert sands!  AGT has teamed up with Arabian Geophysical and Survey Company (ARGAS) to bring our advanced imaging technologies and services to the Middle East and North Africa (MENA) region.',
text2: 'Founded in 1966, ARGAS is a leader in seismic acquisition and a subsidiary of TAQA, which is part of the Saudi sovereign Public Investment Fund (PIF). Together, we’ll power up regional exploration efforts and even support ARGAS’s technical needs for their data acquisition business. MENA — here we come!'},

{id: 20, year: 2024, title: 'AGT Expands Computing Capacity in Malaysia with IPserverone Colocation Agreement',
text: 'AUG/2024',
text1: 'AGT has expanded its computing capabilities in Malaysia through a colocation agreement with IPserverone, located just outside Kuala Lumpur. This facility will serve as a key hub supporting AGT’s growth in Southeast Asia.',
text2: 'The large, robust, and highly secured data center will house AGT’s multi-petaflop computer systems, enabling enhanced capacity and performance for the company’s geophysical services across the region.'},

{id: 19, year: 2024, title: 'AGT Malaysia Welcome Christopher Lee Slind as SEA Regional Manager',
text: 'MAY/2024',
text1: 'With 36+ years of advanced seismic imaging expertise across global basins—including leadership roles at PETRONAS and CGGVeritas, Chris is now heading up AGT’s seismic services across SEA from Kuala Lumpur.',
text2: 'He’ll lead our core offerings in 2D/3D/4D processing, broadband, OBN, and elastic forward modelling, while building strong technical collaborations across the region.',
text3: 'Fun fact: Chris once oversaw a seismic imaging team in Mexico, and can confirm that cockroaches are good swimmers!',
text4: 'Welcome aboard, Chris! We’re excited for what’s next for AGT in SEA.'},

{id: 18, year: 2024, title: 'AGT Partners with Stratoil to Deliver Advanced Technologies to the Egyptian Market',
text: 'JAN/2024',
text1: 'We’re making waves on the Nile!  AGT has signed an agency agreement with Stratoil, a Cairo-based software and consulting firm specializing in subsurface, engineering, and training for the oil and gas world.',
text2: 'Stratoil will lead local business development and provide technical support, helping us bring AGT’s cutting-edge technologies to Egypt’s exploration community. We’re ready to fuel innovation in one of the region’s most dynamic energy markets.'},

{id: 17, year: 2023, title: 'AGT Colombia',
text: 'DEC/2023',
text1: 'AGT is pleased to announce the establishment of our Colombian Branch office located in Bogota, Colombia. Built on the back of a two multi-year seismic processing and imaging contracts we have brought our suite of advanced seismic imaging tools and services to the Colombian market and by extension other areas in the South American region.  Services include seismic data processing of 2D/3D/4D Land/Marine including OBN and broadband acquisitions. Additionally, included in our offering is advanced 3D elastic (Finite Element) and acoustic forward modelling services. ',
text2: 'For further inquiries please reach out to Colombia@agtgeo.com. Phone: +57 3112382512. Address: Calle Av. 19 NO 118-95, Bogotá D.C. For additional inquiries please visit www.agtgeo.com. '},
{id: 16, year: 2023, title: '',
text: 'OCT/2023',
text1: 'AGT has been awarded by the SEG Advanced Modeling Corporation (SEAM) a contract for geophysical simulations (Elastic Modeling etc.) on their 3-year CO2 Sequestration Project.  The purpose of the project is to develop better CO2 subsurface management using synthetic numerical benchmarks. The work program will include numerical models, earth response and monitoring simulations. This continues multi-year awards, by AGT, for various SEAM projects over the last 10 years.  In addition, AGT manages all SEAM data under a separate Agreement.  We appreciate SEAM’s continued support of AGT technical capabilities in this highly compute intensive project. ',
text2: 'For further inquiries please contact AGT @  info@agtgeo.com or SEAM representative Paola Vera @ pvera@seg.org'},
{id: 15, year: 2023, title: '',
text: 'FEB/2023',
text1: 'AGT awarded long term 3+1-year contract for seismic processing contract with a local operator in Colombia.  AGT has already hired existing local workforce and project work been awarded related to the contract.'},
{id: 14, year: 2023, title: '',
text: 'FEB/2023',
text1: 'AGT is pleased to announce the establishment of our SE Asia subsidiary located in Kuala Lumpur, Malaysia. Built on the back of a multi-year processing and imaging contract we have brought our suite of advanced seismic imaging tools and services to the SE Asia region.',
text2: 'Services include seismic data processing of 2D/3D/4D Land/Marine including OBN and broadband acquisitions. Additionally, included in our offering is advanced 3D elastic (Finite Element) and acoustic forward modelling services and AGT handles the management of all SEG’s SEAM consortia data models.',
text3: 'This regional center provides services to the entire SE Asia region. AGT’s presence in the region is in conjunction with our local partners Elsa Energy and Azimuth GeoSolutions. ',
text4: 'For further inquiries please reach out to Malaysia@agtgeo.com .',
text5: 'For additional inquiries please visit www.agtgeo.com. BTW - we are hiring qualified geophysicists in Malaysia.'},
{id: 13, year: 2022, title: '',
text: 'JUL/2022',
text1: 'Through a long standing relationship with SEAM the SEG Advanced Modeling Corporation has chosen AGT to manage the entire SEAM product line of data. Please visit www.seg.org/SEAM/home for more detail.',
text2: 'MAY/2022',
text3: 'AGT is awarded by Ecopetrol S.A. a 3 + 1 year (2022-2026) Framework Agreement contract for seismic processing onshore data in Colombia.  Award based on AGT’s excellent results from the “turkey shoot” AGT performed as part of the benchmark for project award.  This continues a contractual relationship between AGT and Ecopetrol first established in 2018.'},
{id: 12, year: 2021, title: '',
text: 'DEC/2021:    ',
text1: 'AGT awarded SEAM AI Synthetic Data Benchmark project.  Includes synthetic seismic modeling, event identification and travel-time picking.',
text2: 'OCT/2021:    ',
text3:'AGT signs agreement with Invision Geofisica to bring AGT’s suite of advanced imaging technologies and services to the Brazilian market. AGT’s suite of marine imaging technologies including advanced velocity model building and migrations are perfectly suited to support 2D/3D marine acquisition initiatives especially for more recent nodal 3D acquisitions.',
text4:'AUG/2021:    ',
text5:'Multi-year contract award. AGT awarded 5-year marine processing and imaging contract with Nexus Cognitive Government Solutions for indefinite delivery, indefinite quantity of seismic imaging service. The initial work under this agreement has already been defined under two seprate work orders. Continuous work orders are expected under this agreement.',
text6:'APR/2021',
text7:'Multi-year umbrella contract award. AGT along with its Malaysian based partner Azimuth Geosolutions awarded 5-year umbrella contract with Petronas for 2D/3D processing and imaging services. This award primarily based AGT\'s suite of advanced signal processing, velocity model building, and migration technology consists of 2D/3D seismic imaging workflows including newly developed multiple attenuation techniques, velocity model building(i.e. QFWI) and advanced migrations(i. e. LS-PSDM, QRTM etc..). The data regimes are primarily for marine 3D projects in both shallow and deep water geologic environments.',
text8:'MAR/2021',
text9:'AGT signs new long-term lease and relocation to new facilities to accommodate growth in business. New office doubles existing capacity for its\' employees and fully supported with state-of-the-art infrastructure for AGT\' high capacity internally administered computer facility.'},
{id: 1, year: 2020, title: '', 
text:'APR/2020:    ',
text1:'AGT inks 3-year technology collaboration agreement with large IOC around new seismic imaging methodologies related to Machine Learning initiatives.',
text2:'APR/2020:    ',
text3:'AGT awarded 2-year Phase 2 DOE grant #DE-SC0019665 for “Enhance Full-Waveform Inversion with Machine Learned Low-Frequency Signals”.',
text4:'MAR/2020:',
text5:'AGT to present at EAGE workshop “Quantifying Uncertainty in Depth Imaging” in Kuala Lumpur Apr 6-8, 2020.  “Postponed until Oct 26-28 due to Covid-19”',
text6:'MAR/2020',
text7:'AGT files provisional patent for “Broadband full waveform inversion through alternating resotration and inversion of missing frequencies”.',
text8:'JAN/2020:',
text9:'AGT signs partnership agreement with Azimuth Geosolutions to provide seismic imaging and forward modelling services in Malaysia and SE Asia area markets.',
text10:'https://azimuthgeos.com/azimuth-agt/    '},
{id: 2, year: 2019, title: '', 
text:'SEP/2019',
text1:'AGT files patent for RTM angle gather workflow "Systems and methods for providing amplitude versus offset compliant RTMmigration gathers".',
text2:'AUG/2019',
text3:'AGT files provisional patent for "Progressive transfer for low frequency prediction in full waveform inversion".',
text4:'JUN//2019:    ',
text5:'AGT expands in-house multi-PetaFlop compute infrastructure due to significant increase in project awards requiring advanced imaging technologies.',
text6:'MAY/2019:    ',
text7:'AGT doing numerous 3D acquisition studies GOM & Mexico utilizing proprietary forward modeling technologies.',
text8:'APR/2019:    ',
text9:'AGT secures significant 3D work with Ecopetrol in Colombia',
text10:'MAR/2019:    ',
text11:'Signs agreement with University of Houston for support on DOE program.',
text12:'FEB/2019',
text13:'AGT awarded Phase 1 DOE grant #DE-SC0019665 for "Enhance Full-Waveform Inversion with Machine Learned Low-Frequency Signals".',
text14:'FEB/2019:',
text15:'AGT lands large elastic modeling contract offshore Brazil.'
},
{id: 11, year: 2018, title: '',
text:'OCT/2018:    ',
text1:'AGT awarded 3 year framework seismic processing contract for onshore Colombia with Ecopetrol ',
text2:'SEP/2018:    ',
text3:'AGT awarded large Elastic Modelling (Life of Field) contract from SEAM',
text4:'AUG/2018:    ',
text5:'AGT top tier in AVO compliant RTM angle gather benchmark',
text6:'APR/2018:    ',
text7:'Expands further to full-service imaging provider.  Adds staff.',
text8:'APR/2018:    ',
text9:'AGT hires Jack Robinson (35 years experience) to manage signal processing department at AGT.',
text0:'MAR/2018:     ',
text11:'AGT signs agreement with Samit, India for technology and technical support for processing and imaging services. Starts first project.',
text12:'JAN/2018',
text13:'AGT awarded Phase 1 NSF grant #NSF1746834 titled "Deep transfer learning enabled machine vision inspection and its application in exploration geophysics".'
},
{id: 10, year: 2017, title: '',
text:'AUG/2017:    ',
text1:'AGT top tier in AVO compliant RTM angle gather benchmark for major IOC',
text2:'AUG/2017:    ',
text3:'AGT awarded two marine Q-RTM projects',
text4:'MAR/2017:     ',
text5:'AGT office moves as part of expansion plan',
},
{id: 9, year: 2016, title: '',
text:'DEC/2016:    ',
text1:'AGT files Q-RTM patent ',
text2:'SEP/2016:    ',
text3:'AGT finished large SEAM elastic PP model in record time',
text4:'JUL/2016:    ',
text5:'AGT expands GPU compute 100%',
text6:'JUL/2016:    ',
text7:'AGT awarded 6th straight SEAM FM project'
},
{id: 8, year: 2015, title: '',
text:'OCT/2015:    ',
text1:'AGT China completes large software sale.',
text2:'SEP/2015',
text3:'Bill Burke joins AGT as VP Business Development.',
text4:'JUL/2015:     ',
text5:'AGT completes large onshore Q PSDM project.',
text6:'FEB/2015:     ',
text7:'AGT files patent for “Beat Tone” FWI.'
},
{id: 7, year: 2014, title: '',
text:'AUG/2014:    ',
text1:'AGT now in the Leading Edge. ',
text2:'JUN/2014:        ',
text3:'AGT awarded large FM project by large IOC.  Finishes in record time.',
text4:'JUN/2014:        ',
text5:'AGT adds additional hardware to their offsite compute facility due to higher demand for services.', 
text6:'FEB/2014:    ',
text7:'AGT expands service business offerings. Includes full range of depth imaging services',
text8:'JAN/2014:    ',
text9:'AGT office expansion continues:  Adds significantly more space.'
},
{id: 6, year: 2013, title: '',
text:'NOV/2013:    ',
text1:'AGT awarded SEAM Phase2 “Unconventionals” Forward Modeling project.',
text2:'OCT/2013:    ',
text3:'Rob Yorke hired by AGT as their CEO',
text4:'MAR/2013:        ',
text5:'Wenyi Hu joins AGT',
text6:'MAR/2013:        ',
text7:'AGT begins development of FWI technology',
},
{id: 5, year: 2012, title: '',
text:'SEP/2012:    ',
text1:'Jerry Yuan & Xijing Lian join AGT.',
text2:'MAY/2012:        ',
text3:'AGT invests in 1.4 PetaFlop GPU machine for 3D seismic imaging services.',
text4:'MAY/2012:        ',
text5:'Initial development of 3D Kirchhoff migration.',
text6:'MAR/2012:        ',
text7:'AGT establishes permanent presence in China.  Hires 1st employee.',
text8:'MAR/2012:    ',
text9:'AGT starts Velocity Model Building project.',
text10:'FEB/2012:    ',
text11:'Yong Sun joins AGT.',
text12:'JAN/2012:    ',
text13:'AGT office expansion.  Doubles office space.'
},
{id: 4, year: 2011, title: '',
text:'NOV/2011:    ',
text1:'AGT awarded SEAM Phase1(B) Deep Water Gulf of Mexico TTI Forward Modeling Project. ',
text2:'SEP/2011:    ',
text3:'AGT awarded 3 large RTM software licensing sale contracts.',
text4:'JUL/2011:        ',
text5:'AGT sign 1st contract for RTM software licensing sale.',
text6:'MAR/2011:        ',
text7:'AGT signs cooperation agreement with CUPC in Beijing.'
},
{id: 3, year: 2010, title: '',
text:'SEP/2010:     ',
text1:'AGT establish small office in Houston just outside of the Galleria.',
text2:'SEP/2010:  ',
text3:'AGT begins developing RTM migration software.',
text4:'AUG/2010: ',
text5:'Co-Founder Lijian Tan starts up operations.',
text6:'AUG/2010:        ',
text7:'AGT Incorporates.',
}
         ], // a copy of the entirety of news to be saved every time news is modified by a function call
        numNewsItems: 1, // number of news entries to be displayed per page
        page: 0
    }

    componentDidMount() {
        document.title = 'AGT - News';
    }
    
    // convert numNewsItems at a time news entries into NewsItem components
    formatNews = () => {
        var newsJSX = [];
        let i = this.state.page * this.state.numNewsItems;
        while(i<this.state.news.length && i<this.state.page*this.state.numNewsItems + 6){
            let dict = this.state.news[i];
            newsJSX.push(<NewsItem info={dict}/>)
            i++;
        }
        return newsJSX;
    }

    incrementPage = () => {
        const page = this.state.page + 1;
        this.setState({page});
    }

    incrementPageTwice = () => {
        const page = this.state.page + 2;
        this.setState({page});
    }
    
    decrementPage = () => {
        const page = this.state.page - 1;
        this.setState({page});
    }
    
    goFirstPage = () => {
        const page = 0;
        this.setState({page});
    }

    goLastPage = () => {
        const page = Math.ceil(this.state.news.length/this.state.numNewsItems) - 1;
        this.setState({page});
    }

    applyFilter = (year) => {
        var news = this.state.newsReset.filter(o => {return o['year'] === year});
        this.setState({news});
    }

    reset = () => {
        this.setState({news: this.state.newsReset});
    }

    render() { 
        var newsFormatted = this.formatNews();
        return ( 
            <div style={{width: '100vw'}}>
            <div class="container-fluid border border-grey" style={{width: '60vw', minWidth: 700}}>
                <div class="row">
                    <div class="col-2 border-right text-center">
                        <br/>
<Link class="heading" onClick={this.reset} style={{fontSize: 25, fontWeight: 'bold', color: '#00ACD4'}}>All News</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2025)} style={{fontSize: 20, color: 'black'}}>2025</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2024)} style={{fontSize: 20, color: 'black'}}>2024</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2023)} style={{fontSize: 20, color: 'black'}}>2023</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2022)} style={{fontSize: 20, color: 'black'}}>2022</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2021)} style={{fontSize: 20, color: 'black'}}>2021</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2020)} style={{fontSize: 20, color: 'black'}}>2020</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2019)} style={{fontSize: 20, color: 'black'}}>2019</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2018)} style={{fontSize: 20, color: 'black'}}>2018</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2017)} style={{fontSize: 20, color: 'black'}}>2017</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2016)} style={{fontSize: 20, color: 'black'}}>2016</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2015)} style={{fontSize: 20, color: 'black'}}>2015</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2014)} style={{fontSize: 20, color: 'black'}}>2014</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2013)} style={{fontSize: 20, color: 'black'}}>2013</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2012)} style={{fontSize: 20, color: 'black'}}>2012</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2011)} style={{fontSize: 20, color: 'black'}}>2011</Link><br/>
<Link class="subheading" onClick={() => this.applyFilter(2010)} style={{fontSize: 20, color: 'black'}}>2010</Link><br/>
                    </div>
                    <div class="col">
                        <h1 class="heading ml-2 mt-1" style={{fontSize: 35, color: '#5F6062'}}>LATEST NEWS</h1>
                        {newsFormatted}
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <PageNav decrementPage={this.decrementPage} 
                        incrementPage={this.incrementPage}
                        goFirstPage={this.goFirstPage}
                        goLastPage={this.goLastPage}
                        page={this.state.page}
                        incrementPageTwice={this.incrementPageTwice}
                        lastPage={Math.ceil(this.state.news.length/this.state.numNewsItems)}
                        href='/#/News'/>
            </div>
            <Footer class="mt-5" min={700}/>
            </div>
        );
    }
}
